import { createReducer } from 'redux-act';
import * as actions from '../actions/auth';
import { Url } from 'finhelper';
import CacheHelper from '#app/helpers/Cache/CacheHelper';
import LocalStorageHelper from '#app/helpers/Cache/LocalStorageHelper';
import Tracker from '#app/helpers/Tracker';
import { clearFormData } from '#app/pages/Relations/Roboadvisor/utils/subscriptionForm.utils';
import { URL_LOGIN, URL_SUBSCRIBE } from '#app/constants/routes';
import type { AuthUserData, GetUserResponse } from '#app/types/auth';
import { PLAN_PROFILE_FIELDS } from '#app/constants/planProfileFields';

const LANGUAGE_RU = '/ru/';
const LANGUAGE_EN = '/en/';

interface AuthState {
  data: Partial<AuthUserData> | undefined;
  language: number;
  auth: boolean;
  showLoginModal: boolean;
  showRegisterModal: boolean;
  showForgotModal: boolean;
  showSubscribeModal: boolean;
}

const getLanguage = (): number => {
  const storedLanguage = localStorage.getItem(LocalStorageHelper.LANGUAGE);
  const url = Url.getCurrentUrl();

  if (url.includes(LANGUAGE_RU)) {
    localStorage.setItem(LocalStorageHelper.LANGUAGE, String(1));
    return 1;
  } else if (url.includes(LANGUAGE_EN)) {
    localStorage.setItem(LocalStorageHelper.LANGUAGE, String(2));
    return 2;
  }

  return storedLanguage === '1' || storedLanguage === null ? 1 : 2;
};

const saveUrlParamsToLocalStorage = (): void => {
  const params = Url.getParams() as Record<string, string>;

  if (params.crm_client_id) {
    localStorage.setItem('crm_client_id', params.crm_client_id);
  }

  if (params.token) {
    localStorage.setItem('token', params.token);
  }
};

const initializeUserState = (): AuthState => {
  const url = Url.getCurrentUrl();
  const language = getLanguage();

  saveUrlParamsToLocalStorage();

  return {
    data: {},
    language,
    auth: false,
    showLoginModal: URL_LOGIN.includes(url),
    showRegisterModal: false,
    showForgotModal: false,
    showSubscribeModal: url === URL_SUBSCRIBE,
  };
};

const handleLanguage = (state: AuthState, language: number): AuthState => ({
  ...state,
  language,
});

const handleGetUser = (state: AuthState, response: GetUserResponse): AuthState =>
  response?.result === 'success'
    ? {
        ...state,
        data: response.data,
        auth: true,
      }
    : state;

const handleLogout = (state: AuthState): AuthState => {
  CacheHelper.clearAll();
  clearFormData();

  return {
    ...state,
    data: {},
    auth: false,
  };
};

const handleUpdatePlanProfileFields = (
  state: AuthState,
  payload: Partial<Record<(typeof PLAN_PROFILE_FIELDS)[number], unknown>>
): AuthState => {
  if (!state.data) return state;
  return {
    ...state,
    data: {
      ...state.data,
      ...(payload as Partial<AuthUserData>),
    },
  };
};

interface ModalState {
  showLoginModal?: boolean;
  showRegisterModal?: boolean;
  showForgotModal?: boolean;
  showSubscribeModal?: boolean;
}

const handleModalVisibility = (state: AuthState, modalState: ModalState): AuthState => ({
  ...state,
  ...modalState,
});

export default createReducer<AuthState>(
  {
    [actions.handleGetUser as any]: handleGetUser,
    [actions.handleUpdatePlanProfileFields as any]: handleUpdatePlanProfileFields,
    [actions.handleLogout as any]: handleLogout,
    [actions.handleLoginModal as any]: (state: AuthState) =>
      handleModalVisibility(state, {
        showLoginModal: true,
        showRegisterModal: false,
        showForgotModal: false,
      }),
    [actions.handleForgotModal as any]: (state: AuthState) =>
      handleModalVisibility(state, {
        showForgotModal: true,
        showLoginModal: false,
        showRegisterModal: false,
      }),
    [actions.handleRegisterModal as any]: (state: AuthState) => {
      Tracker.reachGoal('register_click');
      return handleModalVisibility(state, {
        showRegisterModal: true,
        showForgotModal: false,
        showLoginModal: false,
      });
    },
    [actions.handleCloseModal as any]: (state: AuthState) =>
      handleModalVisibility(state, {
        showLoginModal: false,
        showRegisterModal: false,
        showForgotModal: false,
        showSubscribeModal: false,
      }),
    [actions.handleLanguage as any]: handleLanguage,
  },
  initializeUserState()
);

////
// import {createReducer} from 'redux-act';
// import * as actions from '../actions/auth';
// import {Url} from "finhelper";
// import CacheHelper from "#app/helpers/Cache/CacheHelper";
// import LocalStorageHelper from "#app/helpers/Cache/LocalStorageHelper";
// import Tracker from "#app/helpers/Tracker";
// import { clearFormData } from '#app/pages/Relations/Roboadvisor/utils/subscriptionForm.utils';
// import { URL_LOGIN, URL_SUBSCRIBE } from '#app/constants/routes';

// const LANGUAGE_RU = '/ru/';
// const LANGUAGE_EN = '/en/';

// // Вспомогательная функция для определения языка
// const getLanguage = () => {
//   let storedLanguage = localStorage.getItem(LocalStorageHelper.LANGUAGE);
//   const url = Url.getCurrentUrl();

//   if (url.includes(LANGUAGE_RU)) {
//     localStorage.setItem(LocalStorageHelper.LANGUAGE, 1);
//     return 1;
//   } else if (url.includes(LANGUAGE_EN)) {
//     localStorage.setItem(LocalStorageHelper.LANGUAGE, 2);
//     return 2;
//   }

//   return storedLanguage === '1' || storedLanguage === null ? 1 : 2;
// };

// const saveUrlParamsToLocalStorage = () => {
//   const params = Url.getParams();

//   if (params.crm_client_id) {
//     localStorage.setItem('crm_client_id', params.crm_client_id);
//   }

//   if (params.token) {
//     localStorage.setItem('token', params.token);
//   }
// };

// // Инициализация состояния пользователя
// const initializeUserState = () => {
//   const url = Url.getCurrentUrl();
//   const language = getLanguage();

//   saveUrlParamsToLocalStorage();

//   return {
//     data: {},
//     language,
//     auth: false,
//     showLoginModal: URL_LOGIN.includes(url),
//     showRegisterModal: false,
//     showForgotModal: false,
//     showSubscribeModal: url === URL_SUBSCRIBE,
//   };
// };

// const handleLanguage = (state, language) => ({
//   ...state,
//   language,
// });

// const handleGetUser = (state, response) => (
//   response?.result === 'success'
//     ? {
//       ...state,
//       data: response.data,
//       auth: true,
//     }
//     : state
// );

// const handleLogout = (state) => {

//   CacheHelper.clearAll();

//   // Очищаем данные паспортных данных из localStorage при выходе
//   clearFormData();

//   return {
//     ...state,
//     data: {},
//     auth: false,
//   };
// };

// const handleModalVisibility = (state, modalState) => ({
//   ...state,
//   ...modalState,
// });

// // Редьюсер
// const reducer = createReducer({
//   [actions.handleGetUser]: handleGetUser,
//   [actions.handleLogout]: handleLogout,
//   [actions.handleLoginModal]: (state) => handleModalVisibility(state, {
//     showLoginModal: true,
//     showRegisterModal: false,
//     showForgotModal: false,
//   }),
//   [actions.handleForgotModal]: (state) => handleModalVisibility(state, {
//     showForgotModal: true,
//     showLoginModal: false,
//     showRegisterModal: false,
//   }),
//   [actions.handleRegisterModal]: (state) => {
//     Tracker.reachGoal('register_click');
//     return handleModalVisibility(state, {
//       showRegisterModal: true,
//       showForgotModal: false,
//       showLoginModal: false,
//     });
//   },
//   [actions.handleCloseModal]: (state) => handleModalVisibility(state, {
//     showLoginModal: false,
//     showRegisterModal: false,
//     showForgotModal: false,
//     showSubscribeModal: false,
//   }),
//   [actions.handleLanguage]: handleLanguage,
// }, initializeUserState());

// export default reducer;
